module.exports = __webpack_public_path__ + "static/gallery7-03b2798e2fe1a3ab481f2cf745fbe3fc.jpg";